import moment from 'moment'
import { isValidDateObject } from '../validator/is-valid-date-object'
import { isValidISO8601 } from '../validator/is-valid-iso-8601'

/**
 * Converts a date/timestamp into a specific format, independent of current locale.
 * (For formatting to current locales, please use the formatters.)
 * @see https://momentjs.com/docs/#/displaying/format/
 * For common formats see formatter constants.
 *
 * @param {Date|string|number} date Date or valid ISO string/number that should be formatted
 * @param {string} [format='YYYY-MM-DDTHH:mm:ssZ'] String of tokens representing the format
 * @return {string|null} Formatted Date string or null if Date cannot be parsed
 */

export function toCustomDatetimeString(date, format = moment.defaultFormat) {
    if (!(isValidDateObject(date) || isValidISO8601(date))) {
        return null
    }

    return moment(date).format(format)
}
